<template>
  <div class="trusted">
    <div class="container">
      <h2 class="h2">
        {{ title }}
      </h2>
      <p class="subtitle">
        {{ subtitle }}
      </p>
      <img
        loading="lazy"
        class="desktop"
        :src="`${require('../../assets/images/' + imageDesktop)}`"
        :alt="title"
      >
      <img
        loading="lazy"
        class="mobile"
        :src="`${require('../../assets/images/' + imageMobile)}`"
        :alt="title"
      >
      <p v-if="footerText" class="footer-note">
        {{ footerText }}
      </p>
      <button
        v-if="button"
        class="btn-primary btn-lg"
        @click="$emit('buttonClicked')"
      >
        {{ buttonTitle }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: { type: String, default: '', required: true },
    subtitle: { type: String, default: '', required: false },
    imageDesktop: { type: String, default: '', required: false },
    imageMobile: { type: String, default: '', required: false },
    footerText: { type: String, default: '', required: false },
    buttonTitle: { type: String, default: '', required: false },
    button: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.trusted {
  padding-top: var(--spacing-120);
  padding-bottom: var(--spacing-120);

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .h2 {
      margin: 0;
      text-align: center;
    }

    .subtitle {
      margin-top: var(--spacing-16);
      margin-bottom: 44px;
      max-width: 750px;
      text-align: center;
      color: var(--main-light-shade-4);
    }

    .footer-note {
      font-size: 21px;
      margin-top: var(--spacing-32);
      max-width: 600px;
      text-align: center;
      color: var(--main-light-shade-4);
    }

    .btn-primary {
      width: 100%;
      max-width: 350px;
      margin-top: var(--spacing-80);
    }

    img {
      max-width: 100%;

      &.mobile {
        display: none;
      }
    }
  }
}

@include bp($bp-mobile) {
  .trusted {
    .container {
      .h2 {
        font-size: 32px;
      }

      .footer-note {
        font-size: 16px;
      }

      .btn-primary {
        margin-top: var(--spacing-36);
      }
    }
  }
}

@include bp($bp-phone) {
  .trusted {
    .container {
      img {
        &.desktop {
          display: none;
        }

        &.mobile {
          display: block;
        }
      }
    }
  }
}
</style>
